export const initialState = {
  surveyTitle: "",
  viewerIsAuthor: false,
  author: null,
  intakeFormElements: null,
  intakeFormLastUpdated: "",
  abbreviatedTZ: "",
  isEditable: false,
  isHopeForm: false,
  isSubmitDialogOpen: false,
  isCancelDialogOpen: false,
  showToast: false,
}

export const reducer = (state, action) => {
  switch (action.type) {
    case "SET_VALUE":
      return { 
        ...state,
        intakeFormElements: state.intakeFormElements
          .map(element => (
            element.questionId === action.questionId 
              ? {...element, value: action.value} 
              : element
            )
          )
      };
    case "LOAD_HOPE_QUESTIONS":
      return {
        ...state,
        intakeFormElements: action.elements,
        isEditable: true,
        isHopeForm: true,
      };
    case "LOAD_INTAKE_QUESTIONS":
      return {
        ...state,
        surveyTitle: action.title,
        viewerIsAuthor: action.viewerIsAuthor,
        author: action.author,
        intakeFormElements: action.elements,
        intakeFormLastUpdated: action.lastUpdated,
        abbreviatedTZ: action.abbreviatedTZ,
        isEditable: true,
        isHopeForm: false,
      };
    case "VIEW_QUESTIONS":
      return {
        ...state,
        surveyTitle: action.title,
        viewerIsAuthor: action.viewerIsAuthor,
        author: action.author,
        intakeFormElements: action.elements,
        intakeFormLastUpdated: action.lastUpdated,
        abbreviatedTZ: action.abbreviatedTZ,
        isEditable: false,
        isHopeForm: false,
      };
    case "TOGGLE_SUBMIT_DIALOG":
      return { ...state, isSubmitDialogOpen: !state.isSubmitDialogOpen };
    case "TOGGLE_CANCEL_DIALOG":
      return { ...state, isCancelDialogOpen: !state.isCancelDialogOpen };
    case "TOGGLE_TOAST": 
      return { ...state, showToast: !state.showToast };
    case "SET_IS_EDITABLE": 
      return { ...state, isEditable: true };
    case "CANCEL_FORM": 
      return { 
        ...state, 
        isCancelDialogOpen: false,
        isEditable: false,
        intakeFormElements: action.elements,
      };
  }
}
